<template>
  <div>
    <div v-if="!loading">
      <div class="summary-card-container">
        <SummaryCard
          v-bind:cardIcon="jobsAppliedIcon"
          v-bind:summaryDescription="'Jobs Applied To'"
          v-bind:totalCount="applicationsCount"
          class="linked-card"
          :eventType="applicationEvent"
          :target="applicationTarget"
          v-on:backToApplications="$emit('backToApplications', 'Applications')"
        />
        <SummaryCard
          v-bind:cardIcon="recommendedIcon"
          v-bind:summaryDescription="'Recommended Jobs'"
          v-bind:totalCount="recommendedCount"
          class="linked-card"
          :eventType="jobEvent"
          :target="jobTarget"
          v-on:backToJobs="$emit('backToJobs', 'Jobs')"
        />
        <SummaryCard
          v-bind:cardIcon="interviewsIcon"
          v-bind:summaryDescription="'Interviews'"
          v-bind:totalCount="interviewCount"
        />
        <SummaryCard
          v-bind:cardIcon="profileView"
          v-bind:summaryDescription="'Hires'"
          v-bind:totalCount="hireCount"
        />
      </div>
      <div class="applicant-dashboard-components">
        <div class="chart-and-joblist">
          <user-dashboard-chart class="user-chart" />

          <div class="dashboard-jobs">
            <DashboardJobsList
              v-if="loaded && jobsList?.length > 0"
              v-bind:jobsList="jobsList"
              v-bind:jobHeading="jobHeading"
              v-bind:userType="userData.userType"
              v-on:backToJobs="$emit('backToJobs', 'Jobs')"
              v-on:applicantJobView="viewAsApplicant"
            />
            <EmptyDashboardState
              v-else
              v-bind:emptyHeading="emptyJob"
              v-bind:desc="jobDesc"
            />
          </div>
        </div>

        <UserActivities
          class="activities"
          v-bind:userData="userData"
        />
      </div>
    </div>
    <div v-if="loading">
      <!-- Loader Component -->
      <Loader />
    </div>
  </div>
</template>
<script>
import UserDashboardChart from '../../components/body/UserDashboardChart.vue';
import UserActivities from '../../components/body/UserActivities.vue';
import SummaryCard from '../../components/SummaryCard.vue';
import DashboardJobsList from '../../components/DashboardJobsList.vue';
import EmptyDashboardState from '../../components/EmptyDashboardState.vue';
import Loader from '../../components/body/Loader.vue';
// Icons
import jobsAppliedIcon from '../../assets/images/summary-jobs-count.svg';
import recommendedIcon from '../../assets/images/recommendedIcons.png';
import interviewsIcon from '../../assets/images/interviewsIcons.png';
import profileView from '../../assets/images/profileViewIcon.png';

export default {
  name: 'ApplicantDashboard',
  props: ['userData'],
  components: {
    UserActivities,
    // JobDescription,
    UserDashboardChart,
    DashboardJobsList,
    EmptyDashboardState,
    SummaryCard,
    Loader
  },
  data() {
    return {
      loading: true,
      loaded: false,
      userType: '',
      jobHeading: 'Recommended Jobs',
      recommendedJobs: null,
      jobsList: [], // used to hold recommendedJobs needed to be passed to the DashboardJobsList component

      emptyJob: 'Recommended Jobs',
      jobDesc: 'No Jobs Available',
      jobsAppliedIcon,
      profileView,
      interviewsIcon,
      recommendedIcon,
      chartData: '',
      applicationsCount: 0,
      recommendedCount: 0,
      interviewCount: 0,
      hireCount: 0,

      jobTarget: 'Jobs',
      jobEvent: 'backToJobs',
      applicationTarget: 'Applications',
      applicationEvent: 'backToApplications',
    };
  },
  async mounted() {
    await this.getPosts();
    this.computeSummaryData();

    if (this.getUserData.userType === 'admin') {
      this.userType = 'Admin';
    } else if (this.getUserData.userType === 'business') {
      this.userType = 'Company';
    } else if (
      this.userData.userType &&
        this.userData.userType === 'normal-user'
    ) {
      this.userType = 'Job Seeker';
    } else {
      this.userType = 'Agency';
    }
  },
  computed: {
    getUserData() {
      return this.$store.state.userData;
    },
    getError() {
      return this.$store.state.error;
    }
  },
  methods: {
    getPosts() {
      this.$store
          .dispatch('getAllPosts')
          .then((res) => {
            let lengthArray = [];
            this.recommendedJobs = [];
            this.jobsList = [];
            let jobs = res.response;

            if (res.response) {

              res.response.forEach((job) => {
                lengthArray.push(job.applicantsList.length);
                if (!job.jobDeadline || new Date(job.jobDeadline) > Date.now()) {
                  job['status'] = 'Active';
                } else if (new Date(job.jobDeadline) <= Date.now()) {
                  job['status'] = 'Closed';
                }
              });

              jobs.forEach((job, index) => {
                // Ensure only active jobs are displayed to the applicant
                if (job.status === 'Active') {
                  let indxOfHighest = lengthArray.indexOf(Math.max(...lengthArray));
                  if (this.recommendedJobs.length < 10) {
                    this.recommendedJobs.push(jobs[indxOfHighest + index]);
                    lengthArray.splice([indxOfHighest], 1);
                  }

                  return lengthArray;

                }

              });

              this.recommendedCount = this.recommendedJobs.length;
              // Set the length of the recommended jobs list
              // if jobs are less than 6 return the number of available jobs
              // else return only the top 6 jobs
              this.recommendedJobs.length =
              this.recommendedJobs.length < 6
              ? this.recommendedJobs.length
              : 6;

              // Pass value of recommended jobs into the jobsList array
              // to render the data using the DashboardJobsList component
              this.jobsList = this.recommendedJobs;
              this.loaded = true;
              this.loading = false;

            } else {
              if(res.error.error){
                this.jobsList = 0;
                this.recommendedJobs = 0;

                this.loading = false;
                this.$toastr.error(res.error.error, 'Failed');
              }
            }
          })
          .catch((error) => {
            this.jobsList = 0;
            this.recommendedJobs = 0;

            this.loading = false;
            this.$toastr.error(error, 'Failed');
            // throw error;
          });
    },
    computeSummaryData() {
      let applications = this.getUserData.myApplications;
      this.applicationsCount = applications.length;

      applications.forEach((app)=> {
        app.status === 'scheduled-for-interview' ?
          this.interviewCount++ : null;
        app.status === 'hired' ?
          this.hireCount++ : null;
      });
    },
    viewAsApplicant (jobId) {
      this.$emit('applicantJobView', jobId);
    },
  }
};
</script>

<style scoped>
  .applicant-dashboard-components {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }
  .summary-card-container {
    display: grid;
    gap: 2.188rem;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    margin-bottom: 2.5rem
  }
  .summary-card-container > div {
    background: var(--white);
    min-height: 154px;
    border-radius: 15px;
    box-shadow: 0px 0px 4px 2px rgba(180, 180, 180, 0.15);
    -webkit-box-shadow: 0px 0px 4px 2px rgba(180, 180, 180, 0.15);
    -moz-box-shadow: 0px 0px 4px 2px rgba(180, 180, 180, 0.15);
  }
  .chart-and-joblist {
    width: 76.5%;
    padding-right: 1.875rem;
  }
  .user-chart {
    margin-bottom: 1.5rem;
  }
  .dashboard-jobs {
    background: var(--white);
    min-height: 154px;
    border-radius: 15px;
    box-shadow: 0px 0px 4px 2px rgba(180, 180, 180, 0.15);
    -webkit-box-shadow: 0px 0px 4px 2px rgba(180, 180, 180, 0.15);
    -moz-box-shadow: 0px 0px 4px 2px rgba(180, 180, 180, 0.15);
  }
  @media only screen and (max-width: 1178px) {
    .summary-card-container {
      display: grid;
      gap: 2.188rem;
      grid-template-columns: 1fr 1fr;
      grid-template-rows: auto;
    }
  }
  @media only screen and (max-width: 1078px) {
    .summary-card-container {
      display: grid;
      gap: 2.188rem;
      grid-template-columns: 1fr 1fr;
      grid-template-rows: auto;
    }
  }
  @media only screen and (max-width: 990px) {
    .applicant-dashboard-components {
      flex-direction: column;
    }
    .chart-and-joblist {
      width: 100%;
      padding-right: unset;
      margin-bottom: 1.875rem;
    }
    .user-activities-container {
      width: 90%;
      margin: auto;
    }
  }
  @media only screen and (max-width: 767px) {
    .summary-card-container {
      display: grid;
      gap: 2.188rem;
      justify-content: center;
      grid-template-columns: 1fr;
      grid-template-rows: auto;
    }
  }
  @media only screen and (max-width: 565px) {
  }
  @media only screen and (max-width: 420px) {
  }
</style>
